import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The 32px squares in the exam history's "المزيد" column — Figma node
 * 16370:190052.
 *
 * White on a gray/300 hairline, an 8px radius, the file's "Shadow/SM", and a
 * 16px glyph in slate/400. A link when it goes somewhere, a button when it
 * opens something, and a disabled button when the exam has nothing behind it —
 * a pending essay has no analysis yet — so the column keeps its three squares
 * and its alignment on every row.
 *
 * The `focus:` colour is not decoration: rsuite's global `a:focus` rule would
 * otherwise repaint a clicked link blue. `StudentHeader` says the rest.
 */
const BOX =
    'tw-flex tw-size-[32px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[8px] ' +
    'tw-border tw-border-solid tw-border-v2-ground-400 tw-bg-white tw-text-v2-student-nav ' +
    'tw-transition-colors';

const LIVE =
    'tw-cursor-pointer hover:tw-border-v2-brand hover:tw-text-v2-brand focus:tw-text-v2-brand ' +
    'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-v2-brand';

const IconButton = ({ to, onClick, label, disabled = false, children }) => {
    if (disabled) {
        return (
            <button type="button" disabled aria-label={label} title={label} className={`${BOX} tw-cursor-not-allowed tw-opacity-40`}>
                {children}
            </button>
        );
    }

    if (to) {
        return (
            <Link to={to} aria-label={label} title={label} className={`${BOX} ${LIVE}`}>
                {children}
            </Link>
        );
    }

    return (
        <button type="button" onClick={onClick} aria-label={label} title={label} className={`${BOX} ${LIVE}`}>
            {children}
        </button>
    );
};

export default IconButton;
